import { SecondarySpinner } from './secondary'
import { useStyles } from './styles'

type SpinerProps = {
  size?: 's' | 'm' | 'l' | 'xl'
  variant?: 'primary' | 'secondary'
  animationDuration?: string
  shrink?: boolean
}

enum sizeEnum {
  's' = 16,
  'm' = 32,
  'l' = 48,
  'xl' = 64,
}

export const Spiner = (props: SpinerProps) => {
  const { size = 'l', variant = 'primary', animationDuration = '850ms', shrink = false } = props
  const { classes } = useStyles({})

  if (variant === 'primary') {
    return (
      <div
        data-size={size}
        className={classes.root}
      >
        <span data-size={size}></span>
      </div>
    )
  }
  if (variant === 'secondary') {
    return (
      <SecondarySpinner
        size={sizeEnum[size]}
        animationDuration={animationDuration}
        disableShrink={!shrink}
      />
    )
  }
}
